export const getPastPerformanceCalculator = state => state.pastPerformanceCalculator;
